module.exports = __webpack_public_path__ + "static/media/PIBKG_indigo.949cc963.png";